export default class {
    constructor() {
        this.isOpen = false;
        this.dropdown_class = ".l-dropdown";
        this.trigger_class = ".l-dropdown__trigger";
        this.active_class = "l-dropdown-active";
        this.other_triggers_class = ".l-gnav__link:not(.l-dropdown__trigger)";
        this.extend_trigger_class = "[data-extend]";

        this.init();
    }

    init() {
        this.dropdowns = [];
        this.triggers = [];
        this.extend_triggers = [];

        this.triggers = document.querySelectorAll(this.trigger_class);
        this.dropdowns = document.querySelectorAll(this.dropdown_class);
        this.other_triggers = document.querySelectorAll(this.other_triggers_class);
        this.extend_triggers = document.querySelectorAll(this.extend_trigger_class);

        if (this.triggers.length > 0) {
            this.triggers.forEach((trigger) => {
                this.addEvent(trigger);
            });
            this.close();
        }
        if (this.other_triggers.length > 0) {
            this.other_triggers.forEach((other_trigger) => {
                this.other_enter(other_trigger);
            });
        }
        if (this.extend_triggers.length > 0) {
            this.extend_triggers.forEach((extend_trigger) => {
                this.addExtendEvent(extend_trigger);
            });
        }
    }

    addEvent(el) {
        el.addEventListener("mouseenter", (e) => {
            this.handler(el, e);
        });
        el.addEventListener("click", (e) => {
            e.preventDefault();
            if (!this.isOpen) {
                this.handler(el, e);
            }
        });

        el.addEventListener("mouseleave", (e) => {
            this.leaveEvent(el);
        });

        window.addEventListener("scroll", () => {
            this.close();
        });
    }

    addExtendEvent(el) {
        el.addEventListener("mouseenter", (e) => {
            this.extendHandler(el);
        });
    }

    extendHandler(el) {
        this.clearAllExtendActive();

        const extendTargetId = el.getAttribute("data-extend");
        const extendTarget = document.getElementById(extendTargetId);

        if (extendTarget) {
            el.classList.add("active");
            extendTarget.classList.add("active");
        }
    }

    clearAllExtendActive() {
        this.extend_triggers.forEach((trigger) => {
            trigger.classList.remove("active");
        });

        this.extend_triggers.forEach((trigger) => {
            const targetId = trigger.getAttribute("data-extend");
            const target = document.getElementById(targetId);
            if (target) {
                target.classList.remove("active");
            }
        });
    }

    open(el, toggle) {
        toggle.classList.add(this.active_class);
        el.classList.add(this.active_class);

        const rect = toggle.getBoundingClientRect();

        if (rect.right > window.innerWidth) {
            toggle.style.right = 0;
        }
        if (rect.left < 0) {
            toggle.style.left = 0;
        }
        this.isOpen = true;
    }

    close() {
        const trigger_actives = document.querySelectorAll(
            this.trigger_class + "." + this.active_class
        );
        const dropdown_actives = document.querySelectorAll(
            this.dropdown_class + "." + this.active_class
        );
        if (dropdown_actives.length > 0) {
            dropdown_actives.forEach((dropdown) => {
                dropdown.classList.remove(this.active_class);
            });
        }
        if (trigger_actives.length > 0) {
            trigger_actives.forEach((trigger) => {
                trigger.classList.remove(this.active_class);
            });
        }
        this.isOpen = false;
    }

    handler(el, e) {
        const toggle = document.querySelector(
            "#" + el.getAttribute("data-toggle")
        );
        const self_open = el.classList.contains(this.active_class);
        if (toggle) {
            this.close();
            if (!self_open) {
                this.open(el, toggle);
            }
        }
    }

    leaveEvent(el) {
        const toggle = document.querySelector(
            "#" + el.getAttribute("data-toggle")
        );
        if (toggle) {
            toggle.addEventListener("mouseleave", () => {
                this.close();
            });
        }
    }

    other_enter(el) {
        el.addEventListener("mouseenter", () => {
            this.close();
        });
    }
}
